import * as tagsConstants from '../constants/tags';

const INITIAL_STATE = {
    tagsList: [],
    isLoading: false,
    error: null,
};

export default function tags(state = INITIAL_STATE, action) {
    switch (action.type) {
        case tagsConstants.FETCH_TAGS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case tagsConstants.FETCH_TAGS_SUCCESS:
            const sortedTagsList = action.payload.sort((prev, next) => prev.count < next.count);
            const tagsList = sortedTagsList.map((tagElement) => tagElement.tag);
            return {
                ...state,
                tagsList,
                isLoading: false,
            };
        case tagsConstants.ADD_TAG:
            return {
                ...state,
                tagsList: [...state.tagsList, action.payload],
            };
        case tagsConstants.FETCH_TAGS_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/tagsReducer.js